import axios from "axios";

// const API_BASE_URL = "https://rcbd4000.elb.cisinlive.com/api/v1/";

// export const API_ORIGIN = "https://rcbd4000.elb.cisinlive.com";

// const API_BASE_URL = "https://api.affordacar.app/api/v1/";


// export const API_ORIGIN = "https://api.affordacar.app";

export const API_BASE_URL = "https://api.affordacarghana.com/api/v1/";

export const API_ORIGIN = "https://api.affordacarghana.com";


let logoutHandler = null;

export const setLogoutFunction = (fn) => {
  logoutHandler = fn;
};

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

api.interceptors.request.use((config) => {
  const token = sessionStorage.getItem("token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

api.interceptors.response.use(
  (response) => response,
  (error) => {
    console.log("API Error:", error.response || error.message);
    if (error.response && error.response.status === 401) {
      console.warn("Unauthorized! Logging out...");

      if (logoutHandler) logoutHandler();
    }

    return Promise.reject(error);
  }
);

export default api;
